import { withRouter } from 'react-router';
import CatalogMenu from './CatalogMenu';

export default withRouter(CatalogMenu);
